import _objectSpread from "@babel/runtime/helpers/objectSpread";
import React, { createContext, useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import actions from '../store/actions/app/actions';
import * as asyncActions from '../store/actions/app/asyncActions';
import bindActionCreators from '../util/bindActionCreators';
var AppContext = createContext();

var AppContextProvider = function AppContextProvider(props) {
  var actions = props.actions,
      appState = props.appState,
      asyncActions = props.asyncActions,
      children = props.children;
  var appApi = useMemo(function () {
    return _objectSpread({
      actions: actions
    }, asyncActions);
  }, [actions, asyncActions]);
  var contextValue = useMemo(function () {
    return [appState, appApi];
  }, [appApi, appState]);
  return React.createElement(AppContext.Provider, {
    value: contextValue
  }, children);
};

var mapStateToProps = function mapStateToProps(_ref) {
  var app = _ref.app;
  return {
    appState: app
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    asyncActions: bindActionCreators(asyncActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContextProvider);
export var useAppContext = function useAppContext() {
  return useContext(AppContext);
};